import { Module } from '@nestjs/common';
import { CarteraModule } from 'src/cartera/cartera.module';
import { ClientesModule } from 'src/clientes/clientes.module';
import { CobranzasModule } from 'src/cobranzas/cobranzas.module';
import { ContabilidadModule } from 'src/contabilidad/contabilidad.module';
import { VendedoresCobradoresModule } from 'src/vendedores-cobradores/vendedores-cobradores.module';
import { winstonConfig } from '../common/logger/winston.config';
import { CobrosController } from './cobros.controller';
import { CobrosService } from './cobros.service';

@Module({
  imports: [ClientesModule, CobranzasModule, ContabilidadModule, VendedoresCobradoresModule, CarteraModule],
  controllers: [CobrosController],
  providers: [CobrosService],
  exports: [CobrosService],
})
export class CobrosModule {}
